export default __webpack_public_path__ + "static/media/AR.56bf8531.svg";